import React, { useState } from 'react'
import ShareButton from '../ShareButton'

function NavbarV2() {
  const [isScrolled, setIsScrolled] = useState(false)

  React.useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className={`navbar z-[100] bg-[#095393] sticky top-0 shadow-sm border-b border-white ${isScrolled ? 'shadow-md' : ''}`}>
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex w-full items-center justify-between">
          {/* Logo Section */}
          <a href="https://www.pdamcilegon.co.id/" className="flex items-center gap-2 flex-shrink-0">
            <img src={`${process.env.PUBLIC_URL}/assets/img/ic_launcher-web-round.png`} className="w-[50px] md:w-[60px]" alt="logo" />
            <div className="flex flex-col">
              <span className="text-white text-sm md:text-base font-semibold leading-tight">
                PERUMDA AIR MINUM CILEGON MANDIRI
              </span>
              <span className="text-white text-xs md:text-sm font-normal leading-tight">
                Kota Cilegon
              </span>
            </div>
          </a>

          {/* Right Side Actions */}
          <div className="flex items-center gap-1">
            <ShareButton />

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <label htmlFor="drawer-v2" className="btn btn-ghost text-white drawer-button">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NavbarV2
